import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function () { return ({
    components: {
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: designTokens.color.gray.slateDefault.value,
                    fontSize: designTokens.typography.caption.captionRegular.size.value,
                    lineHeight: designTokens.typography.caption.captionRegular.lineHeight.value,
                    '&.Mui-focused:not(.Mui-error)': {
                        color: designTokens.color.gray.slateDefault.value,
                    },
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=formLabelTheme.js.map